/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PaymentsServiceSwitchQuotePaymentResult
 */
export interface PaymentsServiceSwitchQuotePaymentResult {
  /**
   *
   * @type {string}
   * @memberof PaymentsServiceSwitchQuotePaymentResult
   */
  message: string;
}

/**
 * Check if a given object implements the PaymentsServiceSwitchQuotePaymentResult interface.
 */
export function instanceOfPaymentsServiceSwitchQuotePaymentResult(
  value: object,
): value is PaymentsServiceSwitchQuotePaymentResult {
  if (!("message" in value) || value["message"] === undefined) return false;
  return true;
}

export function PaymentsServiceSwitchQuotePaymentResultFromJSON(
  json: any,
): PaymentsServiceSwitchQuotePaymentResult {
  return PaymentsServiceSwitchQuotePaymentResultFromJSONTyped(json, false);
}

export function PaymentsServiceSwitchQuotePaymentResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaymentsServiceSwitchQuotePaymentResult {
  if (json == null) {
    return json;
  }
  return {
    message: json["message"],
  };
}

export function PaymentsServiceSwitchQuotePaymentResultToJSON(
  json: any,
): PaymentsServiceSwitchQuotePaymentResult {
  return PaymentsServiceSwitchQuotePaymentResultToJSONTyped(json, false);
}

export function PaymentsServiceSwitchQuotePaymentResultToJSONTyped(
  value?: PaymentsServiceSwitchQuotePaymentResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    message: value["message"],
  };
}
